/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NeonatalTpnStartAliases {
  GLOBAL_ACTIONS = 'global-actions',
  LEGENDS_NEONATAL_TPN_START = 'legends-neonatal-tpn-start',
  NEONATAL_TPN_START_ACCORDION = 'neonatal-tpn-start-accordion',
  NEONATAL_TPN_START_ACCORDION_PANEL = 'neonatal-tpn-start-accordion-panel',
  NEONATAL_TPN_START_ACCORDION_PLUS_TITLE_PANEL = 'neonatal-tpn-start-accordion-plus-title-panel',
  NEONATAL_TPN_START_ACCORDION_PLUS_TITLE_TEXT = 'neonatal-tpn-start-accordion-plus-title-text',
  NEONATAL_TPN_START_ACCORDION_TITLE_PANEL = 'neonatal-tpn-start-accordion-title-panel',
  NEONATAL_TPN_START_ACCORDION_TITLE_TEXT = 'neonatal-tpn-start-accordion-title-text',
  NEONATAL_TPN_START_BARCODE = 'neonatal-tpn-start-barcode',
  NEONATAL_TPN_START_BARCODE_PANEL = 'neonatal-tpn-start-barcode-panel',
  NEONATAL_TPN_START_BUTTON = 'neonatal-tpn-start-button',
  NEONATAL_TPN_START_BUTTON_PANEL_PADDING = 'neonatal-tpn-start-button-panel-padding',
  NEONATAL_TPN_START_CARD = 'neonatal-tpn-start-card',
  NEONATAL_TPN_START_CARD_DECK = 'neonatal-tpn-start-card-deck',
  NEONATAL_TPN_START_CARD_PANEL = 'neonatal-tpn-start-card-panel',
  NEONATAL_TPN_START_CARDS_ACCORDION = 'neonatal-tpn-start-cards-accordion',
  NEONATAL_TPN_START_CARDS_ACCORDION_PANEL = 'neonatal-tpn-start-cards-accordion-panel',
  NEONATAL_TPN_START_CONTENT_PANEL = 'neonatal-tpn-start-content-panel',
  NEONATAL_TPN_START_DATE_TIME_FIELD = 'neonatal-tpn-start-date-time-field',
  NEONATAL_TPN_START_DATE_TIME_TEXT = 'neonatal-tpn-start-date-time-text',
  NEONATAL_TPN_START_DEVICE_AUTOCOMPLETE = 'neonatal-tpn-start-device-autocomplete',
  NEONATAL_TPN_START_DEVICE_FETCH = 'neonatal-tpn-start-device-fetch',
  NEONATAL_TPN_START_DEVICE_FIELD = 'neonatal-tpn-start-device-field',
  NEONATAL_TPN_START_DEVICE_MAPPER = 'neonatal-tpn-start-device-mapper',
  NEONATAL_TPN_START_DEVICE_TEXT = 'neonatal-tpn-start-device-text',
  NEONATAL_TPN_START_FORM = 'neonatal-tpn-start-form',
  NEONATAL_TPN_START_INFUSION_FORM_AUTOCOMPLETE = 'neonatal-tpn-start-infusion-form-autocomplete',
  NEONATAL_TPN_START_INFUSION_FORM_FETCH = 'neonatal-tpn-start-infusion-form-fetch',
  NEONATAL_TPN_START_INFUSION_FORM_FIELD = 'neonatal-tpn-start-infusion-form-field',
  NEONATAL_TPN_START_INFUSION_FORM_MAPPER = 'neonatal-tpn-start-infusion-form-mapper',
  NEONATAL_TPN_START_INFUSION_FORM_TEXT = 'neonatal-tpn-start-infusion-form-text',
  NEONATAL_TPN_START_INFUSION_SPEED_FIELD = 'neonatal-tpn-start-infusion-speed-field',
  NEONATAL_TPN_START_INFUSION_SPEED_INPUT = 'neonatal-tpn-start-infusion-speed-input',
  NEONATAL_TPN_START_LAYOUT = 'neonatal-tpn-start-layout',
  NEONATAL_TPN_START_NAME_DATE_PANEL = 'neonatal-tpn-start-name-date-panel',
  NEONATAL_TPN_START_NAME_FIELD = 'neonatal-tpn-start-name-field',
  NEONATAL_TPN_START_NAME_TEXT = 'neonatal-tpn-start-name-text',
  NEONATAL_TPN_START_NEW_DATE_FIELD = 'neonatal-tpn-start-new-date-field',
  NEONATAL_TPN_START_NEW_DATE_INPUT = 'neonatal-tpn-start-new-date-input',
  NEONATAL_TPN_START_OBSERVATION_TEXT = 'neonatal-tpn-start-observation-text',
  NEONATAL_TPN_START_TEXT_OBSERVATION_FIELD = 'neonatal-tpn-start-text-observation-field',
  NEONATAL_TPN_START_UNITY_AUTOCOMPLETE = 'neonatal-tpn-start-unity-autocomplete',
  NEONATAL_TPN_START_UNITY_FETCH = 'neonatal-tpn-start-unity-fetch',
  NEONATAL_TPN_START_UNITY_FIELD = 'neonatal-tpn-start-unity-field',
  NEONATAL_TPN_START_UNITY_MAPPER = 'neonatal-tpn-start-unity-mapper',
  NEONATAL_TPN_START_UNITY_TEXT = 'neonatal-tpn-start-unity-text',
  NEONATAL_TPN_START_VOLUME_STEP_FIELD = 'neonatal-tpn-start-volume-step-field',
  NEONATAL_TPN_START_VOLUME_STEP_INPUT = 'neonatal-tpn-start-volume-step-input',
}
export { NeonatalTpnStartAliases };
